import { z } from 'zod';

export const LlmModelSchema = z.object({
  created: z.number(),
  id: z.string(),
  object: z.string(),
  owned_by: z.string(),
});

export const LlmModelsResponseSchema = z.object({
  data: z.array(LlmModelSchema),
  object: z.string(),
});

export type ILlmModelDto = z.infer<typeof LlmModelSchema>;
export type ILlmModelsResponseDto = z.infer<typeof LlmModelsResponseSchema>;
